export default "__VITE_ASSET__pzzUlb8E__"